import {
  DEFAULT_CANDIDATES_OVERVIEW_QUERY_PARAMS,
  DEFAULT_FINAL_RESULTS_QUERY_PARAMS,
  DEFAULT_INTERVIEWS_QUERY_PARAMS,
  DEFAULT_SEND_INVITES_QUERY_PARAMS,
  DEFAULT_TEST_SCORES_QUERY_PARAMS,
} from 'constants/projects'

const DETAILS = 'details'
const INTERVIEWS = 'interviews'
const INVITES = 'invites'
const OVERVIEW = 'overview'
const RESULTS = 'results'
const TESTS = 'tests'

export const TAB_NAMES = {
  DETAILS,
  OVERVIEW,
  INVITES,
  TESTS,
  INTERVIEWS,
  RESULTS,
}

export const getDefaultQueryParams = state => {
  const { activeTab } = state

  const queryParams = {
    [TAB_NAMES.DETAILS]: null,
    [TAB_NAMES.OVERVIEW]: DEFAULT_CANDIDATES_OVERVIEW_QUERY_PARAMS,
    [TAB_NAMES.INVITES]: DEFAULT_SEND_INVITES_QUERY_PARAMS,
    [TAB_NAMES.TESTS]: DEFAULT_TEST_SCORES_QUERY_PARAMS,
    [TAB_NAMES.INTERVIEWS]: DEFAULT_INTERVIEWS_QUERY_PARAMS,
    [TAB_NAMES.RESULTS]: DEFAULT_FINAL_RESULTS_QUERY_PARAMS,
  }

  return queryParams[activeTab]
}
